import { Component, OnInit } from '@angular/core';
import {AchatService} from '../../../../../../services/achat/achat.service';

@Component({
  selector: 'app-brouillon-bn-recep',
  templateUrl: './brouillon-bn-recep.component.html',
  styleUrls: ['./brouillon-bn-recep.component.scss']
})
export class BrouillonBnRecepComponent implements OnInit {

    constructor(private dataService: AchatService) {}

    ngOnInit(): void {
        console.log('BrouillonCmdComponent initialized');
        this.dataService.filterBonReceptionByStatus('Brouillon');

    }

}
